export const columnsConfig = [
  {
    id: "id",
    header: "",
    size: 120,
    type: "checkbox",
    getColumnDisplayValue: () => "",
  },
  {
    id: "housingType",
    header: "Housing Type",
    size: 300,
    getColumnDisplayValue: ({ type }) => type,
  },
  {
    id: "housingName",
    header: "Housing Name",
    size: 400,
    type: "anchor",
    getColumnDisplayValue: ({ name }) => name,
  },
  {
    id: "isHousingGeneric",
    header: "Is Housing Generic",
    size: 200,
    getColmnDisplayValue: ({ generic_listing }) =>
      generic_listing ? "Yes" : "No",
  },
  {
    id: "city",
    header: "City",
    size: 200,
    getColumnDisplayValue: ({ city_id_rel }) => city_id_rel?.city || "",
  },
  {
    id: "pricingTier",
    header: "Pricing Tier",
    size: 300,
    getColumnDisplayValue: ({ tier }) => tier?.name || "",
  },
  {
    id: "term",
    header: "Term",
    size: 600,
    getColumnDisplayValue: ({ terms_available }) => {
      return terms_available
        .map((term) => term?.name || "")
        .filter((term) => Boolean(term))
        .toSorted()
        .join(", ");
    },
  },
];
